import { constants } from "./constants";
import { NotificationSettings } from "../../../api/api";
import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("notificationSettings");

export const getNotificationSettingsAction = actionCreator.async<
  void,
  NotificationSettings[]
>(constants.NotificationSettingsGetAll);

export const saveLimitSettingAction = actionCreator.async<
  NotificationSettings,
  NotificationSettings
>(constants.NotificationSettingsSaveLimit);

export const saveEmailSettingAction = actionCreator.async<
  NotificationSettings,
  NotificationSettings
>(constants.NotificationSettingsSaveEmailSettings);

export const saveWebSettingAction = actionCreator.async<
  NotificationSettings,
  NotificationSettings
>(constants.NotificationSettingsSaveWebSettings);
